<ng-container *transloco="let t; read: 'settings.deviceCategories'">
  <div class="componentContainer">
    <section class="xs12col componentHeader">
      <h1>{{t('title')}}</h1>
    </section>

    <section class="oneCol">
      <div class="xs12col">
        <div class="boxContainer">
          <div class="box">
            <kendo-grid
              [data]="deviceCategories$ | async"
              [resizable]="true"
              (edit)="editHandler($event)"
              (add)="addHandler($event)"
              (remove)="removeHandler($event)"
              (save)="saveHandler($event)"
              (cancel)="cancelHandler($event)">

              <ng-template kendoGridToolbarTemplate>
                <a kendoGridAddCommand class="addIcon">
                  <span class="icon">
                    <img src="../../../assets/icons/add-icon.svg">
                  </span>
                  {{t('add')}}
                </a>
              </ng-template>

              <kendo-grid-column field="name" [title]="t('name')" media="(min-width: 993px)">
                <ng-template
                  kendoGridEditTemplate
                  let-isNew="isNew"
                  let-formGroup="formGroup"
                  >
                  <kendo-textbox
                    [formControl]="formGroup.get('name')"
                  ></kendo-textbox>
                  @if (formGroup.get('name').touched && formGroup.get('name').hasError('required') && !formGroup.get('name').value) {
                    <kendo-formerror>
                    {{t('isRequired')}}</kendo-formerror>
                  }
                  @if (formGroup.get('name').hasError('deviceCategoryExists')) {
                    <kendo-formerror>
                    {{t('isNotUnique')}}</kendo-formerror>
                  }
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column field="hasSerialNumber" [title]="t('hasSerialNumber')"  media="(min-width: 993px)">
                <!-- Edit Template -->
                <ng-template
                  kendoGridEditTemplate
                  let-isNew="isNew"
                  let-formGroup="formGroup">
                  <div class="roleItem">
                    <input
                      type="checkbox"
                      kendoCheckBox
                      [hidden]="isInEditing"
                      class="k-checkbox k-checkbox-md k-rounded-md"
                      [formControl]="formGroup.get('hasSerialNumber')"
                      />
                    </div>
                  </ng-template>

                  <!-- Cell Template -->
                  <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                    @if (dataItem.hasSerialNumber) {
                      <div>
                        <img src="../../../assets/icons/check-icon.svg" />
                      </div>
                    }
                    @if (!dataItem.hasSerialNumber) {
                      <div></div>
                    }
                  </ng-template>
                </kendo-grid-column>


                <kendo-grid-command-column
                  [hidden]="!('Permissions.DeviceCategories.Update' | permission) || !('Permissions.DeviceCategories.Delete' | permission)"
                  media="(min-width: 993px)"
                  >
                  <ng-template kendoGridCellTemplate let-isNew="isNew">
                    <a kendoGridEditCommand [attr.tooltip]="t('edit')" flow="up" class="actionIcon"><img src="../../../assets/icons/edit-icon.svg"></a>
                    <a kendoGridRemoveCommand [attr.tooltip]="t('delete')" flow="up" class="actionIcon"><img src="../../../assets/icons/delete-icon.svg"></a>
                    <button kendoGridSaveCommand [disabled]="formGroup?.invalid">
                      {{ isNew ? t('add') : t('save') }}
                    </button>
                    <button kendoGridCancelCommand>
                      {{ isNew ? t('cancel') : t('cancel') }}
                    </button>
                  </ng-template>
                </kendo-grid-command-column>

                <!-- MOBILE GRID -->
                <kendo-grid-column-group media="(max-width: 992px)">

                  <kendo-grid-column>
                    <ng-template kendoGridCellTemplate let-dataItem>
                      <h4 class="mobileGridHeader">{{t('name')}}</h4>
                      <span>{{dataItem.name}}</span>
                    </ng-template>
                    <ng-template
                      kendoGridEditTemplate
                      let-isNew="isNew"
                      let-formGroup="formGroup">
                      <h4 class="mobileGridHeader">{{t('name')}}</h4>
                      <kendo-textbox [formControl]="formGroup.get('name')"></kendo-textbox>
                      @if (formGroup.get('name').hasError('required') && formGroup.get('name').touched) {
                        <kendo-formerror>
                          {{t('isRequired')}}
                        </kendo-formerror>
                      }
                    </ng-template>
                  </kendo-grid-column>

                  <kendo-grid-column>
                    <ng-template kendoGridCellTemplate let-dataItem>
                      @if (dataItem.hasSerialNumber) {
                        <div>
                          <h4 class="mobileGridHeader">{{t('hasSerialNumber')}}</h4>
                          <img src="../../../assets/icons/check-icon.svg">
                        </div>
                      }
                    </ng-template>
                    <ng-template
                      kendoGridEditTemplate
                      let-isNew="isNew"
                      let-formGroup="formGroup">
                      <div class="roleItem">
                        <input
                          type="checkbox"
                          kendoCheckBox
                          [hidden]="isInEditing"
                          class="k-checkbox k-checkbox-md k-rounded-md"
                          [formControl]="formGroup.get('hasSerialNumber')">
                        </div>
                      </ng-template>
                    </kendo-grid-column>

                    <kendo-grid-command-column
                      [hidden]="!('Permissions.DeviceCategories.Update' | permission) || !('Permissions.DeviceCategories.Delete' | permission)"
                      media="(max-width: 992px)"
                      >
                      <ng-template kendoGridCellTemplate let-isNew="isNew">
                        <a kendoGridEditCommand [attr.tooltip]="t('edit')" flow="up" class="actionIcon"><img src="../../../assets/icons/edit-icon.svg"></a>
                        <a kendoGridRemoveCommand [attr.tooltip]="t('delete')" flow="up" class="actionIcon"><img src="../../../assets/icons/delete-icon.svg"></a>
                        <button kendoGridSaveCommand [disabled]="formGroup?.invalid">
                          {{ isNew ? t('add') : t('save') }}
                        </button>
                        <button kendoGridCancelCommand>
                          {{ isNew ? t('cancel') : t('cancel') }}
                        </button>
                      </ng-template>
                    </kendo-grid-command-column>
                  </kendo-grid-column-group>

                  <!-- IF NO RESULTS COULD BE FOUND -->
                  <ng-template kendoGridNoRecordsTemplate>
                    <div class="text pl">{{ t("noResults") }}</div>
                  </ng-template>

                </kendo-grid>
              </div>
            </div>
          </div>
        </section>
      </div>
    </ng-container>
